<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box no-display" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Get Student Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined persistent-hint
                        hint="Please select academic year" @change="getStud()" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list"
                        item-text="display_name" return-object label="Semester" persistent-hint
                        hint="Please select semester" @click="
                show = false;
                putnull();
              " />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete v-model="registration_no" rounded color="#0F2027" :items="stud_list"
                        label="Select Student" item-text="name" item-value="registration_number" outlined dense
                        @click="show = false" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && registration_no && sem.name=='Annual'">
                    <v-btn v-if="sem.name=='Annual'" class="mt-6 button" @click="viewreport()">View Marksheet</v-btn>
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && registration_no && sem">
                    <v-btn class="mt-6 button" @click="getreport()">Print Marksheet</v-btn>
                </v-col>

            </v-row>
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data() {
            return {
                default_value: [],
                dialog_marks: false,
                overlay: false,
                selected: [],
                snackbar: false,
                search: "",
                // extraBreadcrumbItems: [


                // ],
                // breadcrumbClass: "breadcrumb-style1",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                fetch_loader: false,
                show: false,
                course_list: [],
                stud_list: [],
                awspath: "",
                registration_no: null,
                standard: null,
                div: null,
                ay: null,
                leraner_marksheet: [],
                sem: null,
                remark: [],
                semester_list: [],
            };
        },
        methods: {
            viewreport(){
                localStorage.setItem("setay", this.sel_ay_data.ay_id);
                localStorage.setItem("setsem", this.sem.id);
                localStorage.setItem("setreg_no", this.registration_no);
                this.show = true;
                let routeData = this.$router.resolve({ name: "learner-annual-marksheet-icse-pre-prim-view" });
                window.open(routeData.href, "_blank");
            },
            getreport() {
                // alert(this.sem.name)
                // return
                localStorage.setItem("setay", this.sel_ay_data.ay_id);
                localStorage.setItem("setsem", this.sem.id);
                localStorage.setItem("setreg_no", this.registration_no);
                this.show = true;
                if(this.sem.name=='Annual'){
                let routeData = this.$router.resolve({ name: "learner-annual-marksheet-icse-pre-prim-print" });
                window.open(routeData.href, "_blank");
                }else{
                    let routeData = this.$router.resolve({ name: "learner-marksheet-icse-pre-prim-print" });
                window.open(routeData.href, "_blank");
                }
            },
            putnull3() {
                this.show = false;
            },
            putnull() {
                this.registration_no = null;
            },
          
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getStud() {
                const data = {
                    ay: this.sel_ay_data.ay_id,
                };
                axios
                    .post("/Examination/getAllPreprimaryStudents", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.stud_list = res.data.stud_list;
                        } else {
                            alert("Somthing went wrong!!!");
                        }
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                    })
                    .finally(() => {
                        this.comp_load = false;
                    });
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        this.semester_list = res.data.sem_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.onload();
            this.awspath = localStorage.getItem("awspath");
        },
    };
</script>
<style scoped>
    @media print {
        .card {
            border: none !important;
            font-size: large !important;
        }
        .pagebreak {
            page-break-before: always;
        }
        header,
        footer,
        nav,
        date {
            display: none !important;
        }
        table,
        td,
        tr {
            break-inside: avoid-page;
        }
        /* img {
              width: 100% !important;
          } */
        body,
        tr,
        th,
        td {
            font-size: large !important;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"],
        #v-card {
            display: none !important;
        }
        v-card {
            border: none !important;
        }
        @page {
            size: A4;
            margin-top: none;
            padding-top: none;
            size: 15.5in 15.5in;
        }
        thead {
            font-weight: bold !important;
        }
        /* table,
          tr,
          th {
              text-align: center !important;
              margin-top: none;
              padding: none !important;
              border-bottom: 1px solid black;
              border: 1px solid black;
          } */
    }
</style>
